import React from 'react'

export default function DoubleColumn (props) {

  const {
    firstDisplay,
    secondDisplay
  } = props

  return (
    <div>
      {firstDisplay} / {secondDisplay}
    </div>
  )
}